import { render, staticRenderFns } from "./UserChPassword.vue?vue&type=template&id=538de64f&scoped=true"
import script from "./UserChPassword.vue?vue&type=script&lang=js"
export * from "./UserChPassword.vue?vue&type=script&lang=js"
import style0 from "./UserChPassword.vue?vue&type=style&index=0&id=538de64f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538de64f",
  null
  
)

export default component.exports